import {combineReducers} from 'redux';

import tax from './Tax/reducer';
import category from './Category/reducer';
import product from './Product/reducer';
import stockTake from './StockTake/reducer';
import bulkProduct from './BulkProduct/reducer';
import bulkConsignment from './BulkConsignment/reducer';
import staff from './Staff/reducer';
import tillLimit from './TillLimit/reducer';
import dispensary from './Dispensary/reducer';
import staffRole from './StaffRole/reducer';
import staffRoleDiscountRateLimit from './StaffRoleDiscountRateLimit/reducer';
import growOp from './GrowOp/reducer';
import brand from './Brand/reducer';
import supplier from './Supplier/reducer';
import purchaseOrder from './PurchaseOrder/reducer';
import till from './Till/reducer';
import auth from './Auth/reducer';
import user from './User/reducer';
import appUpdate from './reducers/appUpdate';
import sellLimit from './SellLimit/reducer';
import fee from './Fee/reducer';
import regulatoryReportingType from './RegulatoryReporting/reducer';
import regulatoryBody from './RegulatoryBody/reducer';
import regulatoryBodyReportingCategory from './RegulatoryBody/ReportingCategory/reducer';
import regulatoryReportingTypeAssociation from "./Dispensary/RegulatoryReporting/reducer";
import discountReason from "./DiscountReason/reducer";
import returnReason from "./ReturnReason/reducer";

const rootReducer = combineReducers({
  tax,
  category,
  product,
  stockTake,
  bulkProduct,
  bulkConsignment,
  staff,
  tillLimit,
  dispensary,
  staffRole,
  staffRoleDiscountRateLimit,
  growOp,
  brand,
  supplier,
  purchaseOrder,
  till,
  auth,
  user,
  appUpdate,
  sellLimit,
  regulatoryReportingType,
  regulatoryBody,
  regulatoryBodyReportingCategory,
  regulatoryReportingTypeAssociation,
  fee,
  discountReason,
  returnReason,
});

export default rootReducer;



// WEBPACK FOOTER //
// ./src/rootReducer.js